import { colors } from "@/theme/colors";
import { IllustrationSvg } from "./IllustrationSvg";

/** Code lines: [x, y, width, color, opacity] — indented like real source. */
const CODE_LINES: ReadonlyArray<[number, number, number, string, number]> = [
  [44, 46, 40, colors.primary, 0.7],
  [56, 58, 62, colors.divider, 1],
  [56, 70, 46, colors.secondary, 0.5],
  [44, 82, 30, colors.primary, 0.45],
];

/**
 * Flat illustration for the Build step: a code editor with a build-progress
 * bar — short milestones with a working preview after each one.
 */
export function BuildIllustration() {
  return (
    <IllustrationSvg>
      {/* Editor window */}
      <rect
        x="28"
        y="16"
        width="164"
        height="98"
        rx="10"
        fill={colors.paper}
        stroke={colors.divider}
        strokeWidth="2"
      />
      {/* Title bar */}
      <path
        d="M28 26a10 10 0 0 1 10-10h144a10 10 0 0 1 10 10v8H28z"
        fill={colors.tintDeep}
      />
      <circle cx="41" cy="25" r="3" fill={colors.secondary} />
      <circle cx="51" cy="25" r="3" fill={colors.warning} />
      <circle cx="61" cy="25" r="3" fill={colors.success} />
      {/* Code lines */}
      {CODE_LINES.map(([x, y, w, fill, opacity]) => (
        <rect
          key={y}
          x={x}
          y={y}
          width={w}
          height="5"
          rx="2.5"
          fill={fill}
          opacity={opacity}
        />
      ))}
      {/* Build-progress bar */}
      <rect
        x="44"
        y="98"
        width="132"
        height="7"
        rx="3.5"
        fill={colors.divider}
      />
      <rect
        x="44"
        y="98"
        width="82"
        height="7"
        rx="3.5"
        fill={colors.primary}
      />
    </IllustrationSvg>
  );
}
